import React from "react";
import { motion } from "../../lib/motionSafe"; // polku suhteessa komponenttiin
import { Instagram, Facebook, Youtube } from "lucide-react";
import { SiTiktok } from "react-icons/si";

/**
 * Yhtenäinen some-linkkikomponentti.
 *
 * Props:
 * - variant: "footer" | "mobile"  -> asettelu & sijoittelu
 * - className: lisäluokat kontainerille
 * - onItemClick: callback jokaiselle klikkaukselle (esim. mobiilipaneelin sulku)
 * - openInNewTab: avataanko uuteen välilehteen (default true)
 */
export default function SocialLinks({
  variant = "footer",
  className = "",
  onItemClick,
  openInNewTab = true,
}) {
  // Yksi lähde totuudelle — jos osoitteet muuttuvat, muutos tänne riittää
  const links = [
    { id: "instagram", label: "Instagram", href: "https://www.instagram.com/buukkeri/", Icon: Instagram },
    { id: "facebook",  label: "Facebook",  href: "https://facebook.com/buukkeri",      Icon: Facebook  },
    { id: "youtube",   label: "YouTube",   href: "https://www.youtube.com/@Esiintyj%C3%A4v%C3%A4litysBuukkeri", Icon: Youtube },
    { id: "tiktok",    label: "TikTok",    href: "https://www.tiktok.com/@buukkeri",   Icon: SiTiktok  },
  
  ];

  // GA4: turvallinen kutsu jos gtag on alustettu (ei kaadu kehityksessä)
  const trackSocialClick = (network) => {
    try {
      if (typeof window !== "undefined") {
        // GA4
        if (typeof window.gtag === "function") {
          window.gtag("event", "social_click", {
            network,
            method: network,
            event_category: "engagement",
            event_label: network,
          });
        }
        // Fallback: dataLayer (jos GTM käytössä)
        else if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: "social_click", network });
        }
      }
    } catch {}
  };

  const containerBase =
    variant === "mobile"
      ? "flex items-center justify-center gap-3"
      : "flex gap-3";
  const containerClass = [containerBase, className].filter(Boolean).join(" ");

  const anchorBase =
    "group inline-flex h-10 w-10 items-center justify-center rounded-xl " +
    "bg-white/5 ring-1 ring-white/10 hover:bg-white/10";
  const iconClass = "h-5 w-5 text-white group-hover:text-electric";

  return (
    <div className={containerClass}>
      {links.map(({ id, label, href, Icon }) => (
        <motion.a
          key={id}
          href={href}
          aria-label={label}
          title={label}
          target={openInNewTab ? "_blank" : undefined}
          rel={openInNewTab ? "noopener noreferrer" : undefined}
          data-network={id}
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.94 }}
          onClick={() => {
            trackSocialClick(id);
            onItemClick?.(id);
          }}
          className={anchorBase}
        >
          <Icon className={iconClass} aria-hidden="true" />
          <span className="sr-only">{label}</span>
        </motion.a>
      ))}
    </div>
  );
}
